import { useAtomValue } from 'jotai';

import { usePreferences } from '../../react-query/usePreferences';
import { PracticeFeatureFlagKey, useFeatureFlag } from '../../utils/user';

import { hasHuddleDataAtom } from './atoms';

export const useShouldHideHuddle = () => {
  const preferences = usePreferences();
  const isVideaDemoUser = !!useFeatureFlag(PracticeFeatureFlagKey.IS_SALES_DEMO)
    ?.value;
  const isPlanningModeFlagDisabled = !!useFeatureFlag(
    PracticeFeatureFlagKey.PLANNING_MODE_DISABLED,
  )?.value;
  const isPlanningModeDisabled =
    preferences?.data?.isPlanningModeDisabled || isPlanningModeFlagDisabled;
  const hasHuddleData = useAtomValue(hasHuddleDataAtom);

  const isHuddleDisabled = preferences?.data?.huddleDisabled;

  if (
    !isVideaDemoUser &&
    (isPlanningModeDisabled || isHuddleDisabled || hasHuddleData === false)
  ) {
    return true;
  }
  return false;
};
